export default {
    methods: {
        getOrganisationDisplayName(org) {
            return org.displayName
        }
    }
}